<template>
 <!-- 直接使用组件显示数据，不使用表格嵌套 -->
  <div class="data-container">
    <RecordList :tableData="formatDataContent"  />
  </div>
  <!-- 修改为按钮形式的分页组件 -->
  <div class="pagination-container" v-if="pagination.total > 0">
    <el-button
      @click="handlePrevPage"
      :disabled="pagination.page <= 1"
      size="small"
    >
      上一页
    </el-button>

    <span class="page-info">
      第 {{ pagination.page }} 页，共 {{ totalPages }} 页
    </span>

    <el-button
      @click="handleNextPage"
      :disabled="pagination.page >= totalPages"
      size="small"
    >
      下一页
    </el-button>

    <span class="total-info">
      共 {{ pagination.total }} 条记录
    </span>
  </div>
</template>

<script>
import axios from 'axios';

import RecordList from '@/components/RecordList.vue';
import { ElMessage } from "element-plus";

export default {
  components: {
    RecordList
  },
  data() {
    return {

      componentMap: {
        列表: 'RecordList'
      },
      tableData: [],
      filterType: '列表',
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0
      },

      total_principal_label: '100w' // 定义 total_principal_label
    }
  },

    // 在 computed 中添加
    computed: {

      formatDataContent() {
        if (!this.tableData || !Array.isArray(this.tableData) || this.tableData.length === 0) {
          return [];
        }

       return this.generateTableList(this.tableData);

      }
    },





  mounted() {
    this.fetchData();
    this.fetchCustomers();
  },
  methods: {
       // 上一页
        handlePrevPage() {
          if (this.pagination.page > 1) {
            this.pagination.page--;
            this.fetchData();
          }
        },

        // 下一页
        handleNextPage() {
          if (this.pagination.page < this.totalPages) {
            this.pagination.page++;
            this.fetchData();
          }
        },

    async fetchCustomers() {
      try {
        const res = await axios.get("/api/users", {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        });
        this.users = res.data.data || res.data; // 如果有data属性则使用，否则使用整个响应数据
        this.pagination.total = res.data.data.total || this.tableData.length;
      } catch (error) {
        console.error("获取客户列表失败:", error);
        ElMessage.error("获取客户列表失败");
      }
    },
    // 添加 tab 切换处理方法
    handleTabChange(tabName) {
      if (tabName === '列表') {
        this.pagination.pageSize=50;
      }
      this.filterType=tabName;
      this.pagination.page = 1;
      this.fetchData();
    },
    // 根据类型返回组件名称
    getComponentByType(type) {
      console.log('type', type);
      if (!this.componentMap[type]) {
        console.warn(`未找到类型 ${type} 对应的组件，使用默认组件`);
      }
      return this.componentMap[type] || 'RecordList';
    },
    async fetchData() {
      try {
        const response = await axios.get('/api/user_records', {
          params: {
            page: this.pagination.page,
            pageSize: this.pagination.pageSize
          },

          headers: {
            Authorization: `Bearer ${this.$store.state.token}`
          }
        });

        this.tableData = response.data.data;

      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('数据加载失败');
      }
    },
   generateTableList(dataList) {
      try {
        // 处理数据列表，为每条记录创建正确的结构
        console.log(dataList);
        const tableData = dataList.map(item => {
          console.log(item);
          const { stock_code, stock_name } = item.data;
          const username = item.username;
          console.log(username);
          return {
            data: {
              date: item.date || '',
              stock_code: stock_code || '',
              stock_name: stock_name || '',
              user_name: item.username || '',
              types: item.types || ''
            }
          };
        });
        return tableData;
      } catch (error) {
        console.error('生成列表数据错误:', error);
        return [];
      }
    },
  }
}
</script>

<style scoped>
.tabs-container {
  margin-bottom: 20px;
}

.filter-controls {
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
}

.table-wrapper {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

::v-deep .el-table {
  --el-table-border-color: #e9ecef;
  --el-table-header-bg-color: #f8f9fa;
}

::v-deep .el-table th {
  background-color: #f8f9fa !important;
  color: #495057;
  font-weight: 600;
}

::v-deep .el-table tr:hover td {
  background-color: #f8f9fa !important;
}

.data-content {
  margin: 0;
  font-family: Monaco, Consolas, Courier, monospace;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}

.custom-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.query-button {
  padding: 10px 20px;
  transition: all 0.3s ease;
}

.query-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0,123,255,0.3);
}

::v-deep .type-selector .el-input__inner {
  border-radius: 20px;
  padding-left: 35px;
}

@media (max-width: 768px) {
  .table-wrapper {
    overflow-x: auto;
  }

  .filter-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .query-button {
    width: 100%;
  }
}
</style>